import React, { useState, useEffect, useRef } from "react";
import Notification from "../Notification";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import "../../style/Notifications.css";
import api from "../../utils/apiClient";
import PaymentModal from "../PaymentModal";
import Popup from "../Popup";
import usePayment from "../../hooks/usePayment";

function Notifications() {
  const [notis, setNotis] = useState([]);
  const [, setLoading] = useState(true);
  const { authToken, logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropDownRef = useRef(null);
  const [username, setUsername] = useState("");
  const [, setError] = useState(null);
  const [selectednoti, setselectednoti] = useState({
    Mensajero: {
      nombre: "HONDUAUTOS"
    },
    Receptor: {
      nombre: "USUARIO"
    },
    body: "NOTIFICACION"
  });
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [paymentMessage, setPaymentMessage] = useState("");

  const getuser = async () => {
    try {
      const response = await api.get("usuario/getbyToken");
      setUsername(response.data.nombre);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data");
    }
  };

  const deleteNotification = async (id) => {
    try {
      await api.delete("notificaciones/borrar/" + id);
      setNotis(notis.filter(noti => noti._id !== id));
      if (selectednoti._id === id && notis.length > 0) {
        setselectednoti(notis[0]);
      }
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const getnotis = async () => {
    const res = await api.get("notificaciones/misnotis");
    const notidata = res.data;
    setNotis(notidata);
    if (notidata.length !== 0) {
      setselectednoti(res.data[0]);
    }
  };

  useEffect(() => {
    const fetchAllCarros = async () => {
      setLoading(true);
      if (authToken !== null) {
        await getuser();
        await getnotis();
      } else {
        navigate("/");
      }

      await setLoading(false);
    };
    fetchAllCarros();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setnewSelectedNoti = (noti) => {
    setselectednoti(noti);
  };

  const toogleDropdown = () => setIsOpen(!isOpen);

  const {
    showPaymentModal,
    openPaymentModal,
    closePaymentModal,
    confirmPayment,
    paymentSuccess,
    setPaymentSuccess,
    statusMsg,
    setStatusMsg,
    setAuctionId,
    setPendingCarAdId,
    setPendingAdSpaceId,
    paymentsEnabled,
  } = usePayment();

  const handlePay = (noti) => {
    if (!paymentsEnabled) {
      setStatusMsg("Los pagos en línea están temporalmente deshabilitados. Por favor, contáctanos para finalizar tu proceso.");
      return;
    }

    const pendingAdId =
      noti.pendingCarAdId ||
      noti.pendingCarAddId ||
      noti.pendingcaraddId ||
      noti?.pendingCarAd?._id ||
      noti?.pendingCarAdd?._id ||
      "";

    const pendingAdSpaceId =
      noti.pendingAdSpaceId ||
      noti.pendingAdspaceId ||
      noti.pendingadspaceid ||
      noti?.pendingAdSpace?._id ||
      "";

    const amountValue = Number(noti.amount);
    setPaymentAmount(Number.isFinite(amountValue) && amountValue > 0 ? amountValue : 0);

    if (noti.Tipo === "Publicidad") {
      setPaymentMessage("Completa el pago de tu banner para que aparezca en la página principal.");
    } else if (noti.Tipo === "Anuncio") {
      setPaymentMessage("Completa el pago para publicar tu anuncio de vehículo en HONDUAUTOS.");
    } else {
      setPaymentMessage("Este pago es solamente una retención y será devuelto al finalizar la subasta.");
    }

    if (pendingAdId) {
      setPendingCarAdId(pendingAdId);
    } else if (pendingAdSpaceId) {
      setPendingAdSpaceId(pendingAdSpaceId);
    } else {
      setAuctionId(noti.auctionId || "");
    }
    openPaymentModal();
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-user">
          <div className="column-user">
            <p className="user-name">Hola, {username}</p>
            <div className="user-menu">
              <div className="element">
                <img src="icons/car.png" alt="" className="element-img" />
                <a href="/mycars" className="element-text">
                  Mis autos
                </a>
              </div>
              <div className="element">
                <img src="icons/campana.png" alt="" className="element-img" />
                <a href="/notifications" className="element-text">
                  Notificaciones
                </a>
              </div>
              <div className="element">
                <img src="icons/car.png" alt="" className="element-img" />
                <a href="/allcars" className="element-text">
                  Mis compras
                </a>
              </div>
              <div className="element-end" onClick={handleLogout}>
                <img src="icons/salir.png" alt="" className="element-img" />
                <p className="element-text">Salir</p>
              </div>
            </div>
          </div>
          <div className="column-info">
            <div ref={dropDownRef} className="whole-drop-u">
              <button
                onClick={toogleDropdown}
                id="drop-movil"
                className={isOpen ? "click" : ""}
              >
                <p className="d-text">MENU USUARIO</p>
                {isOpen ? (
                  <img
                    src="/icons/arrow-up-dark.png"
                    id="arrows"
                    alt="arrow-up"
                  />
                ) : (
                  <img
                    src="/icons/arrow-down-dark.png"
                    id="arrows"
                    alt="arrow-down"
                  />
                )}
              </button>
              {isOpen && (
                <div className="drop">
                  <div className="user-menu-drop">
                    <div className="element-d">
                      <img src="icons/car.png" alt="" className="element-img" />
                      <a href="/mycars" className="element-text">
                        Mis autos
                      </a>
                    </div>
                    <div className="element-d">
                      <img
                        src="icons/campana.png"
                        alt=""
                        className="element-img"
                      />
                      <a href="/notifications" className="element-text">
                        Notificaciones
                      </a>
                    </div>
                    <div className="element-d">
                      <img src="icons/car.png" alt="" className="element-img" />
                      <a href="/allcars" className="element-text">
                        Mis compras
                      </a>
                    </div>
                    <div className="element-end-d" onClick={handleLogout}>
                      <img
                        src="icons/salir.png"
                        alt=""
                        className="element-img-d"
                      />
                      <p className="element-text-d">Salir</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <p className="main-user-title">Notificaciones</p>
            {notis.length > 0 ? (
              <div className="notifications-grid">
                <div className="column-overview">
                  <div
                    className="overview-container"
                    style={{
                      overflow: "auto",
                      maxHeight: "450px",
                      alignItems: "flex-start",
                    }}
                  >
                    {notis.map((noti) => (
                      <div className="overview-item-n" key={noti._id}>
                        <Notification
                          noti={noti}
                          onDelete={deleteNotification}
                          isSelected={selectednoti && selectednoti._id === noti._id}
                          onSelect={() => setnewSelectedNoti(noti)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="column-content">
                  <p className="from">De: {selectednoti.Mensajero?.nombre || 'Usuario eliminado'}</p>
                  <p className="to">Para: {selectednoti.Receptor?.nombre || 'Usuario eliminado'}</p>
                  <p className="notification-content">
                    {selectednoti.body}
                  </p>
                  {(selectednoti.Tipo === "Anuncio" || selectednoti.Tipo === "Publicidad") && (
                    paymentsEnabled ? (
                      <div className="notification-actions">
                        <button
                          className="pay-noti"
                          onClick={() => handlePay(selectednoti)}
                        >
                          Pagar
                        </button>
                      </div>
                    ) : (
                      <p className="payment-disabled-note">
                        Los pagos en línea están temporalmente deshabilitados. Comunícate con nuestro equipo para completar tu solicitud.
                      </p>
                    )
                  )}
                </div>
              </div>
            ) : (
              <p className="no-notifications">NO TIENES NINGUNA NOTIFICACIÓN</p>
            )}
          </div>
        </div>
      </div>

      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
      {paymentsEnabled && (
        <PaymentModal
          show={showPaymentModal}
          onClose={closePaymentModal}
          onConfirm={confirmPayment}
          message={paymentMessage}
          amount={
            paymentAmount > 0
              ? `L ${paymentAmount.toLocaleString("es-HN")}`
              : null
          }
          orderAmount={paymentAmount || 1}
          paymentsEnabled={paymentsEnabled}
        />
      )}
      {paymentSuccess && (
        <Popup
          message="pago exitoso"
          onClose={() => setPaymentSuccess(false)}
          duration={3000}
        />
      )}
      {statusMsg && (
        <Popup
          message={statusMsg}
          onClose={() => setStatusMsg("")}
          duration={3000}
        />
      )}
    </>
  );
}

export default Notifications;
